import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import classnames from 'classnames';

const styles = theme => ({
  root: {
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: theme.dimensions.xxl,
    margin: '0 auto',
    padding: theme.spacing(1.5, 0),
    color: theme.palette.common.white,
  },
  weekday: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    fontWeight: theme.typography.fontWeightBold,
  },
});

const WeekdaysHeader = ({
  className,
  contentClassName,
  classes,
  days,
}) => {
  return (
    <div className={classnames(classes.root, className)}>
      <div className={classnames(classes.content, contentClassName)}>
        {days.map(weekday => (
          <Typography
            key={weekday}
            variant="h6"
            color="inherit"
            className={classes.weekday}
          >
            {weekday}
          </Typography>
        ))}
      </div>
    </div>
  );
};

WeekdaysHeader.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  classes: PropTypes.object.isRequired,
  days: PropTypes.array,
};

WeekdaysHeader.defaultProps = {
  className: '',
  contentClassName: '',
  days: moment.weekdaysShort(),
};

export default withStyles(styles)(WeekdaysHeader);
